import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  styled,
} from '@nextiva/next-ui-components';
import { pxToRem } from 'utils/pxToRemConverter';
import colors from 'styles/application/_base/_variables.scss';

export const RemoveButton = styled(Button)`
  flex: none;
  height: 40px;
  margin: ${({ error }) =>
    error ? '4px 0 22px 8px !important' : '4px 0 0 8px !important'};
`;

export const AddNumber = styled(Button)`
  &.MuiButtonBase-root {
    margin: 0 0 0 30px;
  }
`;

export const PhoneFormControl = styled(FormControl)`
  margin-bottom: 8px;
`;

export const PhoneNumberTextField = styled(TextField)`
  margin: 0 0 16px 32px;
  width: calc(100% - 32px);
`;

export const ErrorHelperText = styled(FormHelperText)`
  margin: 0 0 0 32px;
  color: #e06969;
`;

export const FormControlComponent = styled(FormControl)`
  margin-bottom: 16px;
`;

export const Item = styled(MenuItem)`
  &.MuiButtonBase-root {
    display: block;
    height: 30px;
    padding: 6px 17px;
    color: #232649;
    font-family: Lato, sans-serif;
    font-weight: 400;
    line-height: 19px;
  }
`;

export const Label = styled(InputLabel)`
  &.MuiInputLabel-outlined {
    transform: translate(0, 1.5px) scale(0.75);
  }
`;

export const RadioGrp = styled(RadioGroup)`
  .MuiRadio-root {
    color: ${colors.secondaryColor};
    border-radius: 50%;
  }
  .MuiRadio-colorSecondary.Mui-checked {
    color: ${colors.primaryBlue};
  }
  .MuiIconButton-root {
    padding: 9px;
  }
  .MuiIconButton-colorSecondary:hover {
    background-color: ${colors.primaryColorHover};
  }
  .MuiTypography-body1 {
    font-size: ${pxToRem('14px')};
  }
`;

// .MuiButtonBase-root is a fix for styles being reordered on dev
export const RadioBtn = styled(Radio)`
  &.MuiButtonBase-root {
    position: relative;
    width: inherit;
    opacity: 1;
  }
`;

// .MuiButtonBase-root is a fix for styles being reordered on dev
export const CheckboxComponent = styled(Checkbox)`
  &.MuiButtonBase-root {
    position: relative;
    width: inherit;
    opacity: 1;
  }
  &.MuiCheckbox-root {
    margin-left: 32px;
    color: ${colors.secondaryColor};
    border-radius: 50%;
  }
  &.MuiCheckbox-root.Mui-checked {
    color: ${colors.primaryBlue};
  }
  &.MuiIconButton-root {
    padding: 9px;
  }
  &.MuiIconButton-colorSecondary:hover {
    background-color: ${colors.primaryColorHover};
  }
  &.MuiCheckbox-colorSecondary.Mui-checked:hover {
    background-color: ${colors.secondaryColorHover};
  }
  &.MuiTypography-body1 {
    font-size: ${pxToRem('14px')};
  }
`;

export const FormLabel = styled(FormControlLabel)`
  margin: 9px 0px;
  .MuiTypography-body1 {
    font-family: Lato, sans-serif;
    font-size: ${pxToRem('14px')};
    line-height: 20px;
    font-weight: 500;
    letter-spacing: 0.21px;
  }
`;
